"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDoctorSubstitutesWithInvitationsListApiResponseSchema = exports.getDoctorSubstituteWithInvitationsItemApiResponseSchema = exports.doctorSubstituteInvitationStatusesSchema = exports.doctorSubstituteInvitationStatuses = void 0;
const zod_1 = require("zod");
const address_schema_1 = require("../global/address.schema");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
exports.doctorSubstituteInvitationStatuses = [
    'pending',
    'confirmed',
    'expired',
];
exports.doctorSubstituteInvitationStatusesSchema = zod_1.z.enum(exports.doctorSubstituteInvitationStatuses);
exports.getDoctorSubstituteWithInvitationsItemApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: (0, api_1.apiEntityTypeSchema)('doctor-substitutes'),
    attributes: zod_1.z.object({
        firstname: zod_1.z.string(),
        lastname: zod_1.z.string(),
        email: zod_1.z.string(),
        orderRegistrationNumber: zod_1.z.string(),
        status: exports.doctorSubstituteInvitationStatusesSchema,
        isInvite: zod_1.z.boolean(),
        thesis: zod_1.z.boolean(),
        installable: zod_1.z.boolean(),
        priority: zod_1.z.number().int().nullable().optional(),
        address: address_schema_1.addressSchema.nullable(),
        /** `null` for an invitation row (no profile yet). */
        profileComplete: zod_1.z.boolean().nullable().default(null),
        createdAt: zod_1.z.coerce.date(),
    }),
});
exports.getDoctorSubstitutesWithInvitationsListApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.getDoctorSubstituteWithInvitationsItemApiResponseSchema);
